import { post } from 'common/apiClient';
import { CreateLinkResponse } from './agent';
export type FilterPayload = {
  LANumber?: string;
  MerchantId?: string;
  OrderId?: string;
  PaymentDateFrom?: string;
  PaymentReferenceNo?: string;
  PaymentRequestId?: number;
  to?: string;
  SourceApplicationName?: string;
  RequestPurpose?: string;
  PaymentPurpose?: string;
  Status?: string;
  RequestStatus?: string;
  Username?: string;
  PageNo?: number;
  PageSize?: number;
  IsExtract?: boolean;
};

export type ReceiptPayload = {
  LoanNumber?: string;
  requestDateFrom?: string;
  paymentRequestId?: string;
  FromDate?: string | null;
  ToDate?: string | null;
  to?: string;
  SourceApplicationName?: string;
  DedupeFromDate?: string;
  DedupeToDate?: string;
  RequestPurpose?: string;
  PaymentPurpose?: string;
  Status?: string;
  RequestStatus?: string;
  Username?: string;
  PageNo?: number;
  PageSize?: number;
  IsExtract?: boolean;
  favourName?: any;
  RequestDate?: any;
  ByAgent?: string;
  verificationReason?: string;
  remarks?: string;
  ConfirmRejectStatus?: string;
  IsDedupe?: number;
};

export type PendingReceiptPayload = {
  LANumber?: string;
  MerchantId?: string;
  OrderId?: string;
  PaymentDateFrom?: string;
  PaymentRef?: string;
  PaymentRequestId?: number;
  To?: string;
  SourceApplicationName?: string;
  RequestPurpose?: string;
  PAYMENTPURPOSE?: string;
  PaymentId?: string;
  new_status?: string;
  RequestStatus?: string;
  Username?: string;
  FeeType?: string;
  pageNo?: number;
  pageSize?: number;
  IsExtract?: boolean;
  ConfirmRejectStatus?: string;
};

export type ReceiptAgentPayload = {
  loanNumber?: string;
  paymentPurpose?: string;
  userId?: string;
  amount?: string;
  srNo?: string;
};

export type AgentReceiptPagedResponse = {
  data: AgentReceiptPagedList;
};
export type AgentReceiptPagedList = {
  ConfirmRejectStatus: string;
  data: {
    currentPageIndex: number | undefined;
    noOfRecords: number;
    data: AgentReceiptListData[];
  };
};

export type PendingReceiptPagedList = {
  data: {
    noOfRecords: number;
    currentPageIndex?: number;
    data: AgentPendingReceiptListData[];
  };
};

export type AgentPayload = {
  id: string;
  email: string;
  isConfirmed: boolean;
};

export type AgentReceiptListData = {
  confirmRejectStatus: string;
  PaymentRequestId: number;
  LoanNumber: string;
  LoanType: string;
  SourceApplicationName: string;
  Mode: string;
  PaymentPurpose: string;
  Amount: number;
  RequestStatus: string;
  PaymentRef: any;
  RefTransaction: any;
  FundingAccount: number;
  bankCode: any;
  Currency: string;
  FavourName: any;
  RequestDate: any;
  ByAgent: string;
  verificationReason: string;
  Status: string;
  remarks: string;
  Action: string;
};

export type AgentPendingReceiptListData = {
  ROWNUM: number;
  PaymentRequestID: number;
  FeeType: string;
  FeeCode: string;
  FeeAmount: number;
  FeeDescription: string;
  LoanNumber: string;
  LoanType: string;
  AccountId: any;
  SourceApplicationName: string;
  RequestPurpose: string;
  Mode: string;
  PAYMENTPURPOSE: string;
  MerchantId: string;
  TotalAmount: number;
  RequestStatus: string;
  Status: string;
  SessionID: string;
  paymentRef: string;
  RefTransaction: string;
  OrderId: string;
  PaymentId: string;
  FundingAccount: string;
  BankCode: string;
  Currency: string;
  valueDate: string;
  favourName: string;
  VerificationReason: string;
  AgentRejectRemarks: string;
  PaymentRequestDateTime: string;
  PennantReceiptDate: string;
  PennantReceiptNo: number;
  AuthCode: any;
  ByAgent: string;
  Remark: string;
  PaymentRequestError: string;
  PennantErrorDesc: string;
  WebhookStatus: string;
  Action: string;
};

export type AuditResponse = {
  data: AuditLog[];
};

export type AuditLog = {
  LANumber: string;
  Event: string;
  EventDateTime: string;
  ErrorDescription: string;
};

export type AuditPayload = {
  paymentRequestId: number;
};

export type ConfirmRejectPayload = {
  paymentRequestId: number;
  status: string;
  agentRejectRemarks: string;
};

export type ConfirmRejectPagedList = {
  data: {
    currentPageIndex: number | undefined;
    noOfRecords: number;
    data: AgentReceiptListData[];
  };
  message: string;
  status: string;
  responseCode: string;
};

export const getAgentReceiptList = (payload?: ReceiptPayload) =>
  post<AgentReceiptPagedList>('/dashboardmodule/getReceiptDashboard', payload);

export const getAgentPendingReceiptList = (payload?: PendingReceiptPayload) =>
  post<PendingReceiptPagedList>('/dashboardmodule/getPendingReceiptDashboard', payload);

// export const getAuditLog = (paymentRequestId: number) =>
// get<AuditResponse>('/agentmodule/getAuditLog?paymentRequestId=' + paymentRequestId);

export const createLink = (payload?: FilterPayload) =>
  post<CreateLinkResponse>('/agentmodule/agentLinkProcessing', payload);

export const getConfirmRejectStatus = (payload?: ConfirmRejectPayload) =>
  post<ConfirmRejectPagedList>('/dashboardmodule/getConfirmRejectStatus', payload);
